import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_ACCOUNT_EXECUTIVE_ACTION_TYPE } from '../actions/accountExecutive.actions';

const initialState = null;

const accountExecutiveReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_ACCOUNT_EXECUTIVE_ACTION_TYPE.SET_ACCOUNT_EXECUTIVE:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default accountExecutiveReducer;
